import PropTypes from 'prop-types';
import React from 'react';
import { formatCurrency } from 'ws-scripts/modules/intl';

import SinglePackage from './SinglePackage';

export default class Packages extends React.Component {
	render() {
		const {
			deviceType,
			packages,
			widgetInfo,
			showPricing,
			locale
		} = this.props;
		if (packages.length === 0) {
			return null;
		}
		return (
			<ul className="list-unstyled">
				{packages.map((singlePackage, idx) => {
					const { name, price, subitems } = singlePackage;
					const formattedPrice =
						price === 0 ? '0' : formatCurrency(price, locale);
					const liStyles = idx === 0 ? '' : 'mt-4 border-top';

					return (
						<li key={name} className={liStyles}>
							<SinglePackage
								deviceType={deviceType}
								idx={idx}
								packageName={name}
								packageOptions={subitems}
								packagePrice={formattedPrice}
								widgetInfo={widgetInfo}
								showPricing={showPricing}
							/>
						</li>
					);
				})}
			</ul>
		);
	}
}

Packages.defaultProps = {
	locale: 'en_US',
	packages: [],
	widgetInfo: {
		windowId: 'packages-options1',
		widgetName: 'ws-packages-options'
	}
};

Packages.propTypes = {
	deviceType: PropTypes.string.isRequired,
	locale: PropTypes.string,
	packages: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			price: PropTypes.number.isRequired,
			subitems: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
		})
	),
	showPricing: PropTypes.bool.isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string,
		widgetName: PropTypes.string
	})
};



// WEBPACK FOOTER //
// ./src/components/Packages.jsx